module.exports = __webpack_public_path__ + "img/IMG_2254_L_Foamcore.18ba2b60.jpg";